export default __webpack_public_path__ + "static/media/jestBW.f687c2d5.webp";